// UserBookingWorkflowModal.jsx
import React from "react";
import classes from "./howItWorksUser.module.css";

const HowItWorksUser = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <button className={classes.closeButton} onClick={onClose}>
          &times;
        </button>

        <div className={classes.modalHeader}>
          <h2 className={classes.modalTitle}>How Bookings Work</h2>
          <p className={classes.modalSubtitle}>
            Understanding your booking journey with ArtistNextDoor
          </p>
        </div>

        <div className={classes.workflowContainer}>
          <div className={classes.stage}>
            <div className={classes.stageHeader}>
              <div className={classes.stageIcon}>
                <span className={classes.iconEmoji}>💰</span>
              </div>
              <h3 className={classes.stageName}>Token Payment</h3>
            </div>
            <div className={classes.stageContent}>
              <p>
                After selecting an artist, you make a token payment to reserve
                your booking request.
              </p>
              <p>
                This token amount is fully refundable if the artist doesn't
                accept your booking.
              </p>
              <p className={classes.note}>
                Your booking now appears in the{" "}
                <span className={classes.highlight}>Pending Approval</span>{" "}
                section.
              </p>
            </div>
          </div>

          <div className={classes.connector}>
            <div className={classes.arrow}></div>
          </div>

          <div className={classes.stage}>
            <div className={classes.stageHeader}>
              <div className={classes.stageIcon}>
                <span className={classes.iconEmoji}>⏳</span>
              </div>
              <h3 className={classes.stageName}>Artist Approval</h3>
            </div>
            <div className={classes.stageContent}>
              <p>
                The artist has <span className={classes.alert}>24 hours</span>{" "}
                to accept or reject your booking request.
              </p>
              <p>
                <strong>If accepted:</strong> Your booking moves to{" "}
                <span className={classes.highlight}>Awaiting Payment</span>{" "}
                section.
              </p>
              <p>
                <strong>If rejected:</strong> Your token amount is refunded to
                your bank account within 3-5 business days.
              </p>
            </div>
          </div>

          <div className={classes.connector}>
            <div className={classes.arrow}></div>
          </div>

          <div className={classes.stage}>
            <div className={classes.stageHeader}>
              <div className={classes.stageIcon}>
                <span className={classes.iconEmoji}>💳</span>
              </div>
              <h3 className={classes.stageName}>Complete Payment</h3>
            </div>
            <div className={classes.stageContent}>
              <p>
                Once the artist accepts, you'll need to complete the full
                payment.
              </p>
              <p>
                You have <span className={classes.alert}>3 days</span> to make
                this payment, or your booking will be automatically canceled.
              </p>
              <p className={classes.note}>
                After payment, your booking moves to the{" "}
                <span className={classes.highlight}>Upcoming</span> section.
              </p>
            </div>
          </div>

          <div className={classes.connector}>
            <div className={classes.arrow}></div>
          </div>

          <div className={classes.stage}>
            <div className={classes.stageHeader}>
              <div className={classes.stageIcon}>
                <span className={classes.iconEmoji}>🎭</span>
              </div>
              <h3 className={classes.stageName}>Event Day</h3>
            </div>
            <div className={classes.stageContent}>
              <p>The artist performs at your event as scheduled.</p>
              <p>Your payment is held securely by ArtistNextDoor.</p>
            </div>
          </div>

          <div className={classes.connector}>
            <div className={classes.arrow}></div>
          </div>

          <div className={classes.stage}>
            <div className={classes.stageHeader}>
              <div className={classes.stageIcon}>
                <span className={classes.iconEmoji}>✅</span>
              </div>
              <h3 className={classes.stageName}>Completion</h3>
            </div>
            <div className={classes.stageContent}>
              <p>
                After the performance, there's a{" "}
                <span className={classes.highlight}>2-day waiting period</span>{" "}
                to ensure everything went well.
              </p>
              <p>If no issues arise, the payment is released to the artist.</p>
              <p>
                Your booking moves to the{" "}
                <span className={classes.highlight}>Completed</span> section.
              </p>
              <p className={classes.note}>
                Don't forget to rate your experience with the artist!
              </p>
            </div>
          </div>
        </div>

        <div className={classes.timelineNote}>
          <h4 className={classes.timelineTitle}>Important Timelines</h4>
          <ul className={classes.timelineList}>
            <li>
              <span className={classes.alert}>24 hours</span>: Artist must
              accept or reject your booking
            </li>
            <li>
              <span className={classes.alert}>3 days</span>: You must complete
              the full payment after artist acceptance
            </li>
            <li>
              <span className={classes.alert}>2 days</span>: Waiting period
              after performance before payment release
            </li>
            <li>
              <span className={classes.alert}>3-5 business days</span>: Refund
              processing time if booking is rejected
            </li>
          </ul>
        </div>

        <div className={classes.modalFooter}>
          <button className={classes.actionButton} onClick={onClose}>
            Got It
          </button>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksUser;
